<div class="place-detail-hours">
  <span *ngIf="place && place.localVerifiedHours" class="schedule-container" [ngClass]="{ 'closed-pointer': !showHours }" [ngStyle]="{ display: showHours ? 'block' : 'inline' }" (click)="showHours = true">

    <div *ngFor="let date of dates">
      <span class="schedule-text" *ngIf="date.day === now || showHours" [ngClass]="{ today: date.day === now && showHours }">
        <p class="schedule-item">
          <span>{{ date.day === now && !showHours ? 'Today' : date.weekDay }}</span>&nbsp;
          <span *ngIf=" (!currentUser || (currentUser && currentUser.verification)) && place.localVerifiedHours && place.localVerifiedHours[date.keyDay].active">
            <span *ngIf="place.localVerifiedHours![date.keyDay].allDay">Open 24 hours</span>
            <span *ngIf="!place.localVerifiedHours![date.keyDay].allDay">{{ place.localVerifiedHours![date.keyDay].begin | date: 'h:mm a' }} - {{ place.localVerifiedHours![date.keyDay].end | date: 'h:mm a' }}</span>
          </span>
          <span *ngIf="!((!currentUser || (currentUser && currentUser.verification)) && (place.localVerifiedHours && place.localVerifiedHours[date.keyDay].active)) && place.localHours![date.keyDay].active">
            <span *ngIf="place.localHours![date.keyDay].allDay">Open 24 hours</span>
            <span *ngIf="!place.localHours![date.keyDay].allDay">{{ place.localHours![date.keyDay].begin | date: 'h:mm a' }} - {{ place.localHours![date.keyDay].end | date: 'h:mm a' }}</span>
          </span>

          <span *ngIf="!((!currentUser || (currentUser && currentUser.verification)) && place.localVerifiedHours &&place.localVerifiedHours[date.keyDay].active) && !place.localHours![date.keyDay].active">Closed</span>
          <span *ngIf="!showHours">&nbsp;&nbsp;&nbsp;<i class="bi bi bi-chevron-down"></i></span>
        </p>
      </span>
    </div>

    <div *ngIf="place.localVerifiedHours && place.is247Verified && currentUser && !currentUser.verification">
      <br/>
      <a [routerLink]="currentUser ? ['/settings', 'verify'] : ['/faq#verification']">* Get verified to have 24/7 access</a>
    </div>

    <div *ngIf="place.localVerifiedHours && !place.is247Verified && currentUser && !currentUser.verification">
      <div *ngFor="let date of dates">
        <div *ngIf=" date.day == now && place.localVerifiedHours[date.keyDay].active">
          <span *ngIf="place.localVerifiedHours[date.keyDay].allDay">
            <a [routerLink]="currentUser ? ['/settings', 'verify'] : ['/faq#verification']">* Get verified to have 24-hour access</a></span>
          <span *ngIf="!place.localVerifiedHours[date.keyDay].allDay">
            <a [routerLink]="currentUser ? ['/settings', 'verify'] : ['/faq#verification']">* Get verified to have access from {{ place.localVerifiedHours[date.keyDay].begin | date: 'h:mm a' }} to {{ place.localVerifiedHours[date.keyDay].end | date: 'h:mm a' }}</a>
          </span>
        </div>
      </div>
    </div>
  </span>
</div>
